import { NgModule } from '@angular/core';
import { CountertopAngleSettingsComponent } from './countertop-angle-settings.component';

@NgModule({
  imports: [CountertopAngleSettingsComponent],
  exports: [CountertopAngleSettingsComponent],
})
export class AngleSettingsModule {}
